import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import THEME from '../../constants/theme';

const PageTitle = ({ title, subtitle, align = 'center', sx }) => {
  return (
    <Box sx={{ textAlign: align, mb: 5, ...sx }}>
      <Box sx={{ position: 'relative', display: 'inline-block', width: align === 'center' ? '100%' : 'auto' }}>
        <Typography 
          variant="h1" 
          component="h1"
          sx={{
            mb: 2,
            fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.PRIMARY,
            fontWeight: 700,
            fontSize: { xs: '2rem', md: '2.8rem' },
            lineHeight: 1.15,
            color: THEME.COLORS.PRIMARY_PURPLE,
            position: 'relative',
            zIndex: 2
          }}
        >
          {title}
        </Typography>
        {/* Decorative underline */}
        <Box sx={{ position: 'absolute', bottom: -8, left: align === 'center' ? '50%' : 0, transform: align === 'center' ? 'translateX(-50%)' : 'translateX(0)', height: 6, width: { xs: 100, md: 180 }, background: 'linear-gradient(90deg, var(--primary-purple), rgba(101,17,175,0.3))', borderRadius: 2 }} />
      </Box>
      {subtitle && (
        <Typography 
          variant="body2" 
          sx={{
            color: THEME.COLORS.NEUTRAL_GRAY_DARK,
            fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
            fontSize: '0.95rem',
            mt: 2,
            fontWeight: 500
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  sx: PropTypes.object
};

export default PageTitle;
